import React, { FC } from 'react'
import { useRouter } from 'next/router'
import { ScrollDimModal } from '~/app/components'
import LeisureInformation from './LeisureInformation'
import { CategoryType } from '~/__generated__/__types__'
import { TOrderDetailsLeisureInformation } from '~/app/components/order-list/hooks/useLeisureInfo'

/**
 * LeisureInformationModal component
 * author: soojin.oh
 */

// type definitions
type Props = {
  isOpened: boolean
  loading: boolean
  leisureInformation?: TOrderDetailsLeisureInformation
  categoryOrderId: string
  categoryOrderType: CategoryType
  refetchOrderDetails: () => void
}

// styled components

const TARGET_ID = 'leisure-information'
// LeisureInformationModal component
const LeisureInformationModal: FC<Props> = function ({
  isOpened,
  loading,
  leisureInformation,
  categoryOrderId,
  categoryOrderType,
  refetchOrderDetails,
}) {
  const { back } = useRouter()
  return (
    <ScrollDimModal isOpened={isOpened} targetId={TARGET_ID}>
      <LeisureInformation
        loading={loading}
        leisureInformation={leisureInformation}
        categoryOrderId={categoryOrderId}
        categoryOrderType={categoryOrderType}
        refetchOrderDetails={refetchOrderDetails}
        onBackClick={() => {
          back()
        }}
      />
    </ScrollDimModal>
  )
}

export default LeisureInformationModal
